import AboutPage from "@/common/components/about/AboutPage";
import { BrowseByLocationPage } from "@/common/components/browse-by-location/BrowseByLocationPage";
import { PAGE_TITLE } from "@/common/constants/constants";
import Head from "next/head";

const BrowseByLocation = () => {
  return (
    <>
      <Head>
        <title>{PAGE_TITLE.BROWSE_BY_LOCATION}</title>
        <meta name="description" content="JozyJobs app" />
      </Head>
      <BrowseByLocationPage />
    </>
  );
};
export default BrowseByLocation;
